/**
 * @module Sagas/SettingUser
 * @desc SettingUser
 */
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { request } from 'src/helpers/request';
import { ActionTypes } from '../constants';
import { isDevelopment } from 'src/module/helpers';


export function* getSetting() {
    try {
        const res = yield call(request, 'get', '/app/setting');
        const { data } = res;

        if (data?.permissions) {
      
            yield put({
                type: ActionTypes.PROFILE_PERMISSIONS_UPDATE,
                payload: data?.permissions
            })
            /* update permission yang disimpan di userprofile */
        }
        if (data?.lock_screen) {
            yield put({
                type: ActionTypes.PROFILE_LOCK_SCREEN_UPDATE,
                payload: data?.lock_screen
            })
            /* update permission yang disimpan di userprofile */
        }

        yield put({
            type: ActionTypes.SETTING_STATE_SUCCESS,
            response: data,
        });
    }
    catch (err) {
        if (isDevelopment)
            console.log(err)
        const ret = err && err.response || null;
        if (ret && ret.status === 401) {
            // alert('tekan keneh')
            localStorage.setItem('authToken', '');
            return yield put({
                type: ActionTypes.USER_AUTH_FAILURE,
                redirect: '/login',
            });
        }
        yield put({
            type: ActionTypes.SETTING_STATE_FAILED,
            response: ret,
        });
    }
}
/**
 * SettingUser Sagas
 */
export default function* root() {
    yield all([takeLatest(ActionTypes.SETTING_STATE, getSetting)]);
}
